export default "__VITE_ASSET__ObZiTuut__"